<template>
  <div>
    <v-dialog v-model="openComputed" max-width="700" persistent>
      <v-card v-if="openComputed">
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t(`label.edoklady`) }}
          <v-spacer />
          <!--v-icon large @click="edokladyCancelTransaction()">{{ mdiClose }}</v-icon-->
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col cols="4">
              <div>
                <div v-if="showPlaceholders()">
                  <!--Skeleton does not allow more than 200-->
                  <v-skeleton-loader style="border-radius: 0" class="pa-0 ma-0" height="200px" max-width="200" type="image" />
                  <v-skeleton-loader style="border-radius: 0" class="pa-0 ma-0" height="50px" max-width="200" type="image" />
                </div>
                <div v-else>
                  <img v-if="$store.state.websocket.edoklady.result" :src="$store.state.websocket.edoklady.result.portrait" height="250" />
                </div>
              </div>
            </v-col>
            <v-col cols="6" class="mt-3">
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $t(`label.name`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="100" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ $store.state.websocket.edoklady.result.givenName }} </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $t(`label.surname`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="140" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ $store.state.websocket.edoklady.result.familyName }} </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $tc(`label.document`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="80" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ $store.state.websocket.edoklady.result.documentName }} </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $tc(`label.documentno`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="100" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ $store.state.websocket.edoklady.result.number }} </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $tc(`label.expire`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="100" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ momentFormat($store.state.websocket.edoklady.result.expiryDate) }} </v-col>
              </v-row>
              <v-row>
                <v-col class="py-1 font-weight-bold" cols="5"> {{ $tc(`label.country`) }}: </v-col>
                <v-skeleton-loader v-if="showPlaceholders()" class="mt-2 ml-2" width="100" type="text" />
                <v-col v-else class="py-1" cols="7"> {{ $store.state.websocket.edoklady.result.country }} </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div style="height: 45px">
            <div class="mt-4">
              {{ $t(`msg.edc_${$store.state.websocket.edoklady.state}`) }}
            </div>
            <div>
              {{ $t(`msg.edcr_${$store.state.websocket.edoklady.resultState}`) }}
            </div>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="colorCancel" @click="edokladyCancelTransaction()">{{ $t('btn.ed_cancel') }}</v-btn>
          <v-spacer />
          <v-btn color="colorSave" @click="saveData()" :disabled="showPlaceholders()">{{ $t('btn.ed_confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t(`label.error`) }}
          <v-spacer />
          <v-icon large @click="dialogError = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 25px; color: brown" class="my-8">{{ $t(`msg.ed_${dialogErrorMessage}`) }}</div>
        </v-card-text>
        <v-divider />
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';

import { mdiClose } from '@mdi/js';

export default Vue.extend({
  name: 'confirmDialog',
  props: {
    header: String,
    body: String,
    openDialog: Boolean,
  },
  data: function () {
    return {
      document: {
        country: '',
        documentno: '',
        documenttype: '',
        expire: '',
        name: '',
        surname: '',
        tranFrom: '', // reader (ctecka), input (form), log (aktualne transakce click)
        entryType: '', // reader, manual - kontrola zmeny zosnimanych dat
      },
      dialogError: false,
      dialogErrorMessage: '',
      mdiClose: mdiClose,
    };
  },
  watch: {
    '$store.state.websocket.edoklady.state'() {
      const state = this.$store.state.websocket.edoklady.state;
      // If transaction running, and browser reload - open dialog but do not start NEW transaction
      if (state === 'OPEN' || state === 'WAITING_FOR_RESPONSE') {
        this.openComputed === false ? this.$emit('update:openDialog', true) : null;
      }
    },
  },
  computed: {
    openComputed(): boolean {
      let state = this.$store.state.websocket.edoklady.state;
      if (this.openDialog && state !== 'OPEN' && state !== 'WAITING_FOR_RESPONSE' && state !== 'RESPONSE_RECEIVED') {
        this.edokladyStartTransaction();
        this.$store.commit('currentDocument', {});
      }
      return this.openDialog;
    },
  },
  methods: {
    edokladyStartTransaction() {
      axios
        .get('/api/v1/edoklady/start')
        .then(() => {})
        .catch((err) => {
          if (err.response.data.message === 'invalidQRcode' || err.response.data.message === 'QRcodeExpired') {
            this.$emit('update:openDialog', false);
            this.dialogErrorMessage = err.response.data.message;
            this.dialogError = true;
            return;
          }
          this.$store.dispatch('catchErrHandler', err);
          this.$emit('update:openDialog', false);
        });
    },
    edokladyCancelTransaction() {
      axios
        .get('/api/v1/edoklady/cancel')
        .then(() => {})
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.$emit('update:openDialog', false);
          this.$store.dispatch('cleanEdokladyState');
        });
    },
    saveData() {
      this.document.tranFrom = 'edoklady';
      this.document.entryType = 'edoklady';
      this.document.name = this.$store.state.websocket.edoklady.result.givenName;
      this.document.surname = this.$store.state.websocket.edoklady.result.familyName;
      this.document.documenttype = this.$store.state.websocket.edoklady.result.documentName;
      this.document.documentno = this.$store.state.websocket.edoklady.result.number;
      this.document.expire = this.$store.state.websocket.edoklady.result.expiryDate;
      this.document.country = this.$store.state.websocket.edoklady.result.country;
      this.$store.commit('currentDocument', this.document);
      this.$emit('update:openDialog', false);
      this.$store.dispatch('cleanEdokladyState');
    },
    momentFormat(inputDate: string) {
      return this.$moment(inputDate, 'YYYY-MM-DD', true).isValid()
        ? this.$moment(inputDate, 'YYYY-MM-DD').format(this.$store.state.auth.df.date)
        : '';
    },
    showPlaceholders() {
      if (
        this.$store.state.websocket.edoklady.resultState &&
        (this.$store.state.websocket.edoklady.resultState === 'SUCCESS' || this.$store.state.websocket.edoklady.resultState === 'UNTRUSTED')
      ) {
        return false;
      }
      return true;
    },
  },
});
</script>
